import { Routes } from '@angular/router';
import { TIP_DEV_ROUTES } from './tip/dev-routes';

/**
 * Two areas, each loaded lazily with its own styles: the tip pages under `/tip`, and parking (`''` with `?location=`
 * and `receipt/:id`). The shell imports neither.
 */
export const routes: Routes = [
  ...TIP_DEV_ROUTES,
  { path: 'tip', loadChildren: () => import('./tip/tip.routes').then((m) => m.TIP_ROUTES) },
  { path: '', loadChildren: () => import('./parking/parking.routes').then((m) => m.PARKING_ROUTES) },
];
